import { render } from "./BaseErrorIcon.vue?vue&type=template&id=1aba750e"
import script from "./BaseErrorIcon.vue?vue&type=script&lang=js"
export * from "./BaseErrorIcon.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__